module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAc0lEQVR42u3QQREAIAwDwUrFCU6wybMgor9sZk5Atrq7kos+DwAAAAAAAAAAAADA7+7qyaZXZ40GAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJAGkBgAAAAAAAAAAAABAaA8O7SaToYbBMwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Cote-dIvoire.png
// module id = DBYu
// module chunks = 0 62 63